export class GetAccountInfoUseCase {
    constructor(userService) {
        Object.defineProperty(this, "userService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: userService
        });
    }
    async execute() {
        return await this.userService.getAccountInfo();
    }
}
export class UpdateUserLocaleUseCase {
    constructor(userRepository) {
        Object.defineProperty(this, "userRepository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: userRepository
        });
    }
    async execute(locale) {
        // Update user locale in Keycloak via BFF
        await this.userRepository.updateUserLocale(locale);
    }
}
